import { Form, Row, Col, Button, Select } from "antd";
import { ALL_METHOD, ALL_MODULES } from "../../../utils/constants/permissions";

function PermissionSearch(props: any) {
  const [form] = Form.useForm();
  const onFinish = async (values: any) => {
    let query = "";
    if (values.method) {
      query += `&method=${values.method}`;
    }
    if (values.module) {
      query += `&module=${values.module}`;
    }

    if (values.method || values.module) {
      props.handleSearch(query);
    } else {
      props.handleSearch("");
    }
  };

  const resetForm = () => {
    form.resetFields();
  };
  return (
    <Form form={form} onFinish={onFinish}>
      <Row
        gutter={24}
        style={{
          background: "#fff",
          paddingTop: 25,
          margin: 0,
          marginBottom: 20,
          borderRadius: 6,
        }}>
        <Col span={8}>
          <Form.Item name="method" label="Method">
            <Select defaultValue="" options={ALL_METHOD} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="module" label="Module">
            <Select defaultValue="" options={ALL_MODULES} />
          </Form.Item>
        </Col>

        <Col
          span={8}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}>
          <Button
            type="primary"
            onClick={() => {
              form.submit();
            }}
            style={{ marginRight: 12 }}>
            Tìm kiếm
          </Button>
          <Button type="primary" danger onClick={resetForm}>
            Làm lại
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default PermissionSearch;
